import { call, put } from "redux-saga/effects";

import { api, notify } from "services";
import { ICreateRequest } from "interfaces/create-duck";
import { requestErrorHandler } from "utils";
import { UploadDeliveryReceiptSchedulingFOBActions } from "store/ducks/ordersFob";

export function* uploadDeliveryReceiptSchedulingFOBActionsRequest(action: any) {
  try {
    const { postData, onSuccess } = action as ICreateRequest;

    const { data: responseBody } = yield call(
      api.post,
      `/file-scheduling-fob`,
      postData
    );
	
    yield put(UploadDeliveryReceiptSchedulingFOBActions.success(responseBody));
	if (onSuccess) onSuccess(responseBody);
    notify("success", "Arquivo enviado com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(UploadDeliveryReceiptSchedulingFOBActions.failure(errorMessage));
  }
}